export default __webpack_public_path__ + "static/media/logo-mfbrst.e03e8a13.png";